import Skeleton from 'react-loading-skeleton';

import Button from '~/shared/components/ButtonsV2';
import Typography from '~/shared/components/Typography';
import BoltIcon from '~/shared/assets/icons/bolt.svg';
import FilterButton from '~/shared/components/filters/FilterButton';
import Guard from '~/shared/components/Guard';

import AutoscaleRulesLegend from './AutoscaleRulesLegend';

interface AutoscaleRulesHeaderProps {
  rulesCount: number | undefined;
  isLoading?: boolean;
  activeFilterCount: number;
  onOpenFilters: () => void;
  onClearFilters: () => void;
  onCreateRule: () => void;
}

export default function AutoscaleRulesHeader({
  rulesCount,
  isLoading = false,
  activeFilterCount,
  onOpenFilters,
  onClearFilters,
  onCreateRule,
}: AutoscaleRulesHeaderProps) {
  return (
    <div className="gap-2 ">
      <div className="flex justify-between items-center mt-3 4xl:mt-[18px] mb-3.5">
        <div className="flex  gap-7">
          {isLoading && rulesCount === undefined ? (
            <Skeleton
              containerClassName="block leading-[unset!important]"
              className="h-[20px] leading-[unset!important] rounded-[8px]"
              baseColor="var(--color-gray-200)"
              highlightColor="#FFFF"
              width={200}
            />
          ) : (
            <Typography variant="p1-resp" fontWeight={500} color="text-primary-900 " className="">
              {rulesCount} Automatic Scaling Rules
            </Typography>
          ) }
          <AutoscaleRulesLegend />
        </div>
        <div className="flex gap-4 items-center">
          <FilterButton
            activeFilterCount={activeFilterCount}
            onOpen={onOpenFilters}
            onClearAll={onClearFilters}
            label="Filters"
            className=""
            size="md-responsive"
            variant="third"
          />
          <Guard permission="datafy.write.autoscaling.rules">
            <Button
              className="flex gap-2 items-center "
              leftIcon={<BoltIcon className="size-5 aspect-square text-white" />}
              onClick={onCreateRule}
              size="md-responsive"
            >
              <Typography variant="p3" color="">
                Create new rule
              </Typography>
            </Button>
          </Guard>
        </div>
      </div>
    </div>
  );
}
